import { createStore } from 'vuex';

export default createStore({
	state() {
		return {
			windowWidth: 0,
			mobileBreakpoint: 1024,
			isPosting: false,
		};
	},
	mutations: {
		setWindowWidth(state, data) {
			state.windowWidth = data;
		},
		setIsPosting(state, data) {
			state.isPosting = data;
		},
	},
	getters: {
		windowWidth: (state) => state.windowWidth,
		mobileBreakpoint: (state) => state.mobileBreakpoint,
		isPosting: (state) => state.isPosting,
	},
});
